import React from 'react';

export default function TokenSelectorPill({
  token = null,
  onClick,
  disabled = false,
}) {
  // Handle null token - show placeholder
  if (!token) {
    return (
      <button
        type="button"
        className="ts-pill"
        onClick={onClick}
        aria-label="Select token"
      >
        <span className="ts-body">
          <span className="ts-symbol">Select Token</span>
          <svg className="ts-chevron" width="19" height="19" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M8 10l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </span>
      </button>
    );
  }

  return (
    <button
      type="button"
      className={`ts-pill ${disabled ? "is-disabled" : ""}`}
      onClick={onClick}
      aria-label={`Select token ${token.symbol}`}
    >
      {/* Pill body */}
      <span className="ts-body">
        <span className="ts-token-icon" style={{ "--tcolor": token.color || "#2775CA" }}>
          {token.logo ? (
            <img src={token.logo} alt="" />
          ) : (
            <span className="ts-token-fallback">
              <i className="fas fa-coins"></i>
            </span>
          )}
        </span>
        <span className="ts-symbol">{token.symbol}</span>
        <svg className="ts-chevron" width="19" height="19" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M8 10l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </span>
    </button>
  );
}
